import { Step } from '~components/wizard-form/props';
import AssignResults from '~support-at-home/components/budgets/bulk-sah-assign/AssignResults';
import ReviewMatches from '~support-at-home/components/budgets/bulk-sah-assign/ReviewMatches';
import SelectBudgets from '~support-at-home/components/budgets/bulk-sah-assign/SelectBudgets';

import { SahAssignment } from '~support-at-home/actions/budgets';

const bulkSahAssignFields: Step[] = [
  {
    step: 1,
    title: 'Select Budgets',
    fields: {
      budget_ids: {
        type: 'custom',
        component: SelectBudgets,
        colSize: 12,
      },
    },
    disableNext: ({ values }) => !values.budget_ids?.length,
    nextButtonCaption: 'Preview SAH Matches',
  },
  {
    step: 2,
    title: 'Review Matches',
    fields: {
      review_matches: {
        type: 'custom',
        component: ReviewMatches,
        dependencies: ['budget_ids', 'assignments'],
        colSize: 12,
      },
    },
    // Keep "Confirm Assignments" disabled until preview data has arrived (assignments
    // initialised) and every checked row has a SAH budget selected. ReviewMatches surfaces
    // the per-row "Select a SAH budget first" error inline, so validation feedback stays
    // self-contained within the component rather than relying on the shared FormField border.
    disableNext: ({ values }) =>
      values.assignments === undefined || (values.assignments as SahAssignment[]).some((a) => a.sah_budget_id === null),
    nextButtonCaption: 'Confirm Assignments',
  },
  {
    step: 3,
    title: 'Assign',
    fields: {
      assign_results: {
        type: 'custom',
        component: AssignResults,
        dependencies: ['budget_ids', 'assignments'],
        colSize: 12,
      },
    },
    showPrevButton: false,
  },
];

export default bulkSahAssignFields;
